import React from 'react';

function Footer() {
  return (
    <footer>
      <p>
        © {new Date().getFullYear()}{' '}
        <a href="https://ishan.vip" target="_blank" rel="noopener noreferrer">
          Ishan Jaiswal
        </a>
      </p>
    </footer>
  );
}

export default Footer;